import React from 'react';

import serializeJsonLd from './jsonld-serialize';

const SITE_URL = 'https://polypane.app';

export default ({ headline, description, url, ogimage, date, updated }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: serializeJsonLd({
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': `${SITE_URL}${url}`,
        },
        headline,
        image: [`${SITE_URL}/og-images/${ogimage}.png`],
        datePublished: date,
        dateModified: updated || date,
        author: {
          '@type': 'Person',
          name: 'Kilian Valkhof',
        },
        publisher: {
          '@type': 'Organization',
          name: 'Polypane',
          logo: {
            '@type': 'ImageObject',
            url: `${SITE_URL}/general/logo.png`,
          },
        },
        description,
      }),
    }}
  />
);
